const COORDS_REGEXP = /^(\-?\d+(\.\d+)?),\s*(\-?\d+(\.\d+)?)$/;

function googleMapsCoords() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: (scope, elem, attrs, modelCtrl) => {
      modelCtrl.$validators.googleMapsCoords = (value) => (value || '').length === 0 || COORDS_REGEXP.test(value);
    },
  };
}

export default googleMapsCoords;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/google-maps-coords-validator/google-maps-coords-directive.js